export default [
  {
    path: '/records/sme/ticket/list',
    name: 'smeTicketList',
    component: () => import('@/views/records/sme/list'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/sme/tickets/detail',
    name: 'smeTicketsDetail',
    // component: () => import('@/views/tickets/detail'),
    component: () => import('@/views/sme/detail'),
    meta: {
      keepAlive: false
    }
  },
]
